enum Region {
  FLANDERS = 'FLANDERS',
  BRUSSELS = 'BRUSSELS',
  WALLONIA = 'WALLONIA',
}

export default Region;
